module.exports = __webpack_public_path__ + "static/media/arrow-up2.48cf10d1.svg";